import Socialmedia from "./Socialmedia/Socilamedia";

const Footer = () => {
  return (
    <>
      <div className="container-fluid footer dark-background">
        <div className="heights"></div>
        <div className="row mx-3">
          <div className=" col-xs-12 col-md-12 col-lg-3  offset-lg-1">
            <div className="d-flex aligin-items-center">
              <img
                className="img-fluid logo-footer mb-4"
                src="./assets/images/logo_footer.png"
                alt="logo_footer"
              />
            </div>
            {/* <p className="text footer-text">
              VENSAP Cloud ERP Solution is driven by the vision of a seasoned
              finance professional to redefine how organizations manage their
              business processes and empower professionals worldwide. Built on
              decades of cross-industry experience spanning diverse geographies
              and company sizes, VENSAP offers a robust, plug-and-play cloud ERP
              platform designed to support the growth and efficiency of modern
              enterprises.
            </p> */}
            {/* Newsletter */}
            <div className="footer-newsletter">
              <p className="newsletter-title">Subscribe To Our Newsletter</p>

              <div className="newsletter-input-wrapper">
                <input
                  type="email"
                  placeholder="Enter Email Address *"
                  className="newsletter-input"
                />
                <button className="newsletter-btn">➤</button>
              </div>
            </div>
          </div>

          <div className=" col-xs-12 col-md-12 col-lg-2 offset-lg-1">
            <p className="fw-medium">About Us</p>
            <div className="text">
              <p>Careers</p>

              <p>Terms & Conditions</p>
              <p>Privacy Policy</p>
            </div>
          </div>
          {/* Products */}
          <div className="col-xs-12 col-md-12 col-lg-2">
            <p className="fw-medium">Products</p>
            <div className="text footer-products">
              <p>
                <a href="/product#vendoremanagement">
                  Purchase Partner Management
                </a>
              </p>
              <p>
                <a href="/product#vendoremanagement">
                  Customer Sales Management
                </a>
              </p>
              <p>
                <a href="/product#vendoremanagement">Asset Management</a>
              </p>
              <p>
                <a href="/product#vendoremanagement">Production Management</a>
              </p>
              <p>
                <a href="/product#vendoremanagement">AP Automation</a>
              </p>
              <p>
                <a href="/product#vendoremanagement">
                  Product Hub and Life Cycle
                </a>
              </p>
              <p>
                <a href="/product#vendoremanagement">Logistics Management</a>
              </p>
              <p>
                <a href="/product#vendoremanagement">
                  Supply Inventory Management
                </a>
              </p>
              <p>
                <a href="/product#vendoremanagement">Profit Ledger</a>
              </p>
            </div>
          </div>

          <div className=" col-xs-12 col-md-12 col-lg-3">
            <p className="fw-medium">Contact Us</p>
            <div className="text">
              <p>
                No:45, Vanidasan Street Saram(Py) Pondicherry Pondicherry India
                605013
              </p>
              <p>Email: sales@vensap.com</p>
              <div className="socilamedia">
                <Socialmedia />
              </div>
            </div>
          </div>
        </div>
        <div className="heights"></div>
      </div>
      {/* Copyright */}
      <div className="row">
        <div className="col-12 text-center copyright">
          © 2026 VENSAP. All Rights Reserved.
        </div>
      </div>
    </>
  );
};
export default Footer;
